import React, { useState } from 'react'
import Label from 'core/components/label/Label';
import TypographyView from 'common/views/typographyView/Typography.view';
import { BoxView } from 'common/views/box/Box.view';

const ShippableUserDetails = (props) => {
    const userDetails = props.userDetails;

    return (
        <React.Fragment>
            <TypographyView viewKey="user.review.heading" >
                <Label k={"review.heading"} v={"Review"} />
            </TypographyView>

            <TypographyView viewKey="user.review.message" >
                <Label k={"review.message"} v={`Please confirm your order information. By clicking on place order, an invoice will be generated and emailed to you.
                    Once payment is received, course will be made available to you within 3-5 business days. Please follow instructions outlined on the invoice to avoid processing delays. For concerns please contact support.`} />
            </TypographyView>
            <BoxView viewKey="entered-details-Preview">
                <TypographyView viewKey="user.shipping.information" >
                    <Label k={"shipping.information"} v={"Shipping Information"} />
                </TypographyView>
                <TypographyView viewKey="user.Name" >
                    <Label k={"name"} v={"Name"} /> : {userDetails.name}
                </TypographyView>
                <TypographyView viewKey="user.AddressState" >
                    <Label k={"state"} v={"State"} /> : {userDetails.state}
                </TypographyView>
                <TypographyView viewKey="user.AddressCity" >
                    <Label k={"city"} v={"City"} /> : {userDetails.city}
                </TypographyView>
                <TypographyView viewKey="user.Areazipcode" >
                    <Label k={"zipcode"} v={"Zipcode"} /> : {userDetails.zipCode}
                </TypographyView>
                <TypographyView viewKey="user.AddressCountry" >
                    <Label k={"country"} v={"Country"} /> : {userDetails.country}
                </TypographyView>
            </BoxView>
        </React.Fragment>
    )
}

export default ShippableUserDetails;




// WEBPACK FOOTER //
// ./src/panels/catalog/cart/ShippableUserDetails.tsx